import { render, staticRenderFns } from "./customerorder-status-chip.vue?vue&type=template&id=4ddd453f&"
import script from "./customerorder-status-chip.vue?vue&type=script&lang=js&"
export * from "./customerorder-status-chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports